import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    TextField,
    Avatar,
    Icon,
    Tooltip,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    IconButton,
    Grid,
    colors,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Switch,
    MenuItem,
    Select
} from '@material-ui/core';


import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';

import { RiAlarmWarningLine } from "react-icons/ri";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 350,
        minHeight: 350
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    fieldset: {
        margin: 15
    },
    inputvalue: {
        width: 70
    },
    selectvalue: {
        width: 170,
        height: 40
    },
    btnadd: {
        marginBottom: 10
    }
}));


const operators = { equal: 'Igual', notEqual: 'Diferente', lessThan: 'Menor que', lessThanInclusive: 'Menor ou igual a', greaterThan: 'Maior que', greaterThanInclusive: 'Maior ou igual a' };
const generation = { fail: 'Falha', warn: 'Atenção' }

const Test = ({ item, closeEdition, updateValues, open, field }) => {

    const classes = useStyles();

    const handleChangeOperator1 = (event) => {
        item.operator1 = event.target.value;
    };

    const handleChangeOperator2 = (event) => {
        item.operator2 = event.target.value;
    };

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md" >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Monitor para Porta {field.order} - {field.name}
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                    >
                        <Formik
                            initialValues={item}
                            validationSchema={
                                Yup.object().shape({
                                    monitor: Yup.string().max(50).required('Nome do monitor é obrigatória'),
                                    condition: Yup.string().max(50).required('Mensagen de condição é obrigatória'),
                                    result: Yup.string().max(50).required('Mensagem de resultado final é obrigatória'),
                                    operator1: Yup.string().max(50).required('Operação de alrme é obrigatória'),
                                    value1: Yup.number().required('Valor de alarme é obrigatório')
                                })
                            }
                            onSubmit={(values, formik) => {
                                updateValues(values);
                                formik.setSubmitting(false);
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                touched,
                                values
                            }) => (
                                <form onSubmit={handleSubmit}>

                                    <Grid
                                        container
                                        alignItems="flex-start"
                                        spacing={2}
                                    >
                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.monitor && errors.monitor)}
                                                fullWidth
                                                required
                                                helperText={touched.monitor && errors.monitor}
                                                label="Nome do Teste"
                                                margin="normal"
                                                name="monitor"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.monitor}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.condition && errors.condition)}
                                                fullWidth
                                                required
                                                helperText={touched.condition && errors.condition}
                                                label="Descrição da Condição"
                                                margin="none"
                                                name="condition"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.condition}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                    </Grid>

                                    <br></br>

                                    <TableContainer component={PerfectScrollbar}>

                                        <Table stickyHeader size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                        Condição
                                                    </TableCell>
                                                    <TableCell>
                                                        Operação
                                                    </TableCell>
                                                    <TableCell>
                                                        Valor
                                                    </TableCell>
                                                    <TableCell>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow hover >
                                                    <TableCell>
                                                        <Box alignItems="center" display="flex">
                                                            <Avatar
                                                                className={classes.avatar}
                                                            >
                                                                {<Icon component={RiAlarmWarningLine} style={{ color: colors.indigo[400] }} ></Icon>}
                                                            </Avatar>
                                                            Alarma se o Valor de {field.name} for
                                                        </Box>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Select notched
                                                            className={classes.selectvalue}
                                                            required={true}
                                                            error={Boolean(touched.operator1 && errors.operator1)}
                                                            fullWidth
                                                            variant='outlined'
                                                            helperText={touched.operator1 && errors.operator1}
                                                            name="operator1"
                                                            id="operator1"
                                                            onBlur={handleBlur}
                                                            onChange={handleChangeOperator1}
                                                            value={values.operator1}
                                                            inputProps={{
                                                                name: 'operator1',
                                                                id: 'operator1',
                                                            }}
                                                        >
                                                            <MenuItem key={null} value={null}>Nenhum</MenuItem>
                                                            <MenuItem key={'equal'} value={'equal'}> Igual</MenuItem>
                                                            <MenuItem key={'notEqual'} value={'notEqual'}>Diferente</MenuItem>
                                                            <MenuItem key={'lessThan'} value={'lessThan'}> Menor que</MenuItem>
                                                            <MenuItem key={'lessThanInclusive'} value={'lessThanInclusive'}> Menor ou igual a</MenuItem>
                                                            <MenuItem key={'greaterThan'} value={'greaterThan'}> Maior que</MenuItem>
                                                            <MenuItem key={'greaterThanInclusive'} value={'greaterThanInclusive'}> Maior ou igual a</MenuItem>
                                                        </Select>
                                                    </TableCell>

                                                    <TableCell>
                                                        <TextField
                                                            className={classes.inputvalue}
                                                            error={Boolean(touched.value1 && errors.value1)}
                                                            fullWidth
                                                            helperText={touched.value1 && errors.value1}
                                                            margin="normal"
                                                            name="value1"
                                                            variant='outlined'
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            value={values.value1}
                                                            InputLabelProps={{ shrink: true }}
                                                        />


                                                    </TableCell>

                                                    <TableCell >
                                                        <Tooltip title="Excluir monitor do campo de entrada">
                                                            <IconButton
                                                                disabled={true}
                                                                color="secondary"
                                                                className={classes.btntreatment}
                                                                children={<DeleteRoundedIcon />}
                                                                size="medium">
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>

                                                </TableRow>

                                                <TableRow hover >
                                                    <TableCell>
                                                        <Box alignItems="center" display="flex">
                                                            <Avatar
                                                                className={classes.avatar}
                                                            >
                                                                {<Icon component={RiAlarmWarningLine} style={{ color: colors.indigo[400] }} ></Icon>}
                                                            </Avatar>
                                                            Continua Alarmando enquanto o Valor de {field.name} for
                                                        </Box>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Select notched
                                                            className={classes.selectvalue}
                                                            error={Boolean(touched.operator2 && errors.operator2)}
                                                            fullWidth
                                                            helperText={touched.operator2 && errors.operator2}
                                                            name="operator2"
                                                            onBlur={handleBlur}
                                                            value={values.operator2}
                                                            onChange={handleChangeOperator2}
                                                            inputProps={{
                                                                name: 'operator2',
                                                                id: 'operator2',
                                                            }}
                                                        >
                                                            <MenuItem key={null} value={null}>Nenhum</MenuItem>
                                                            <MenuItem key={'equal'} value={'equal'}> Igual</MenuItem>
                                                            <MenuItem key={'notEqual'} value={'notEqual'}>Diferente</MenuItem>
                                                            <MenuItem key={'lessThan'} value={'lessThan'}> Menor que</MenuItem>
                                                            <MenuItem key={'lessThanInclusive'} value={'lessThanInclusive'}> Menor ou igual a</MenuItem>
                                                            <MenuItem key={'greaterThan'} value={'greaterThan'}> Maior que</MenuItem>
                                                            <MenuItem key={'greaterThanInclusive'} value={'greaterThanInclusive'}> Maior ou igual a</MenuItem>
                                                        </Select>
                                                    </TableCell>

                                                    <TableCell>
                                                        <TextField
                                                            className={classes.inputvalue}
                                                            error={Boolean(touched.value2 && errors.value2)}
                                                            fullWidth
                                                            helperText={touched.value2 && errors.value2}
                                                            margin="normal"
                                                            name="value2"
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            value={values.value2}
                                                            InputLabelProps={{ shrink: true }}
                                                        />


                                                    </TableCell>

                                                    <TableCell >
                                                        <Tooltip title="Excluir monitor do campo de entrada">
                                                            <IconButton
                                                                disabled={true}
                                                                color="secondary"
                                                                className={classes.btntreatment}
                                                                children={<DeleteRoundedIcon />}
                                                                size="medium">
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>

                                                </TableRow>

                                            </TableBody>
                                        </Table>
                                    </TableContainer>


                                    <Grid
                                        container
                                        alignItems="flex-end"
                                        spacing={1}
                                    >

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.result && errors.result)}
                                                fullWidth
                                                required
                                                helperText={touched.result && errors.result}
                                                label="Mensagem de Resultado da Condição"
                                                margin="normal"
                                                name="result"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.result}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <Grid container
                                                alignItems='baseline'
                                            >
                                                <Grid item>
                                                    <Switch
                                                        id={values._id}
                                                        checked={values.enabled}
                                                        name="enabled"
                                                        onChange={handleChange} >
                                                    </Switch>
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="h6">Habilitar ou desabilitar monitor</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Box my={1}></Box>
                                    <Divider />

                                    <Box my={1}>
                                        <Grid container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="baseline"
                                            spacing={1}  >
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    type="submit"
                                                    variant="contained">
                                                    Salvar
                                                </Button>
                                            </Grid>
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => { closeEdition() }}>
                                                    Cancelar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </form>
                            )}
                        </Formik>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Test;
